module.exports = __webpack_public_path__ + "teqbahn-assets/media/gi3.10e41e16.png";